<script>
	document.getElementsByTagName('body')[0].style.display = 'none'
	
	import { push } from 'svelte-spa-router'
	import { sQuery as sq } from './sq'
    //import Docs from "./Docs.svelte";
    //import Hello from "./pages/Hello.svelte";
    //import Hello2 from "./pages/Hello2.svelte";

	window.loadProc = function(){
		sq('body').hide().fadeIn(400)

		sq(document).onf('click', '.menu__toggler', function(){
			let el = sq('.menu__toggler')
			el.toggleClass('active')
			if ( sq('.menu__toggler').hasClass('active') )
				sq('#idLeft').fadeIn(500).animate([{left:"-200px"}, {left:"0px"}], 300)
			else	
				sq('#idLeft').fadeOut(500).animate([{left:"0px"}, {left:"-200px"}], 300)
			
			return false
		})
	}

	if (sq().isPageLoaded())
	{
		console.log('spa loaded')
		window.loadProc()
		//setTimeout(() => {
		//	window.loadProc()
		//}, 1);
	}
	sq(()=>{
		console.log('loaded')
		window.loadProc()
	})
</script>

<!--main>
	sq(()=>{
		sq('button').on('click', function(){
			console.log('aa')
			push('/docs')
		})
	})

	<button id="aa">aaa</button>
	<div on:click={() => push('/docs')}>Docs</div>
</main-->

<main>
	<link rel="stylesheet" href="./Docs.css">
	<section id="idHead">
		<span id="idDocNav"></span>
		<div class="cBtnTrans"><a href="https://squery-vercel-app.translate.goog/?&_x_tr_sl=auto&_x_tr_tl=ja&_x_tr_hl=en&_x_tr_pto=wapp">日本語に翻訳</a></div>
	</section>
	
	<section id="idLeft">
		<section id="idLeftTop">
			<div id="idLeftLogo" class="notranslate"><a href="./" style="color:#fff">sQuery v1.03</a></div>
		</section>
		<section class="cScrollable">
			<div style="font-weight:300">
				<div name="" class="cSub">Learn</div>
				<div name="" class="cF"><a href="./#/docs/">documentation</a></div>
				<!--div name="" class="cF"><a href="./#/examples/">examples</a></div-->
				<div name="" class="cF"><a href="./#/sq/">online editor</a></div>
			</div>
	
			<div name="" class="cSub">Community</div>
			<div name="" class="cF"><a href="https://beacons.ai/exis" target=_blank>About me</a></div>
			<div name="" class="cF"><a href="https://github.com/exis9/sQuery" target=_blank>github</a></div>
			<div name="" class="cF"><a href="https://twitter.com/ExisVR" target=_blank class="notranslate">twitter</a></div>
			<div name="" class="cF"><a href="https://stackoverflow.com/questions/tagged/squery" target=_blank>questions</a></div>
			<div name="" class="cF"><a href="#a" onclick="alert('Sorry! Please contact me using twitter DM for now..!');return false">e-mail</a></div>
		</section>
	</section>
	

	<div class="menu__toggler"><span></span></div>

	<section id="idDoc">
		<slot></slot>
		<br><br>
	</section>
</main>
